import { render } from "./App.vue?vue&type=template&id=cb9c4fe6"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__